import FriendContent from './FriendContent'
import './friends.css'

const Friends = ({data}) => {

      if(data.data) return 

      return (
            <div className="friends_content">
                  <div className="friends_title">
                        <h2>{data.length} Friends</h2>
                  </div>
                  <div className="friends_slider">
                        <FriendContent friends={data} />
                  </div>
            </div>
      )
}

export default Friends
